import React, { useState } from "react";
import { Phone, MessageSquare, SlidersHorizontal, CheckCircle2 } from "lucide-react";
import { HANDOFF_STEPS } from "../../data/mock";

const ICONS = [Phone, MessageSquare, SlidersHorizontal, CheckCircle2];

export default function Handoff() {
  const [mode, setMode] = useState("after");
  const steps = HANDOFF_STEPS[mode];

  return (
    <section id="how-it-works" className="bg-mist grain px-5 md:px-8 py-20 lg:py-28">
      <div className="max-w-[1240px] mx-auto">
        <p className="font-mono text-[12px] uppercase tracking-[0.18em] text-teal">
          02 <span className="text-navy/40">—</span> The handoff
        </p>

        <div className="mt-5 grid lg:grid-cols-2 gap-8 lg:gap-16 items-start">
          <h2 className="font-grotesk font-bold leading-[1.0] tracking-tight text-[clamp(2.25rem,5vw,4.25rem)]">
            <span className="text-navy">From ring to response.</span>{" "}
            <span className="text-teal italic">Without the runaround.</span>
          </h2>
          <p className="lg:pt-6 text-navy/70 text-lg leading-relaxed max-w-md">
            CallRetrieve fits around the way your business already answers. See how calls move during or after business hours.
          </p>
        </div>

        {/* Toggle */}
        <div className="mt-10 inline-flex items-center p-1 bg-white rounded-full border border-navy/10">
          {[
            { k: "after", label: "After hours" },
            { k: "business", label: "Business hours" },
          ].map((t) => (
            <button
              key={t.k}
              onClick={() => setMode(t.k)}
              className={`px-5 py-2 rounded-full text-[14px] font-medium transition-all duration-300 ${
                mode === t.k ? "bg-navy text-cream" : "text-navy/60 hover:text-navy"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {/* Steps */}
        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-y-10">
          {steps.map((s, i) => {
            const Icon = ICONS[i];
            const isLast = i === steps.length - 1;
            return (
              <div
                key={`${mode}-${i}`}
                className={`fade-up lg:px-8 lg:first:pl-0 ${
                  i !== 0 ? "lg:border-l border-navy/12" : ""
                }`}
                style={{ animationDelay: `${i * 0.08}s` }}
              >
                <div className="flex items-center justify-between">
                  <span className="font-mono text-[13px] text-navy/45">{s.n}</span>
                  <span
                    className={`w-9 h-9 rounded-full flex items-center justify-center ${
                      isLast ? "bg-lime" : "bg-navy/5"
                    }`}
                  >
                    <Icon className={`w-[18px] h-[18px] ${isLast ? "text-navy" : "text-teal"}`} />
                  </span>
                </div>
                <h3 className="mt-6 font-grotesk text-xl font-semibold text-navy">{s.title}</h3>
                <p className="mt-3 text-navy/60 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
